export const getSafeNumber = (n: string | undefined): number | null => {
  if (n === undefined) {
    return null;
  }
  const number = parseInt(n, 10);
  if (Number.isNaN(number)) {
    return null;
  }
  return number;
};
